/** Riders list [351:495](https://www.figma.com/design/w336KCNkLvp8mdckFFaN2B/RAPID-V1-DRAFTS?node-id=351-495) */
export const ADMIN_RIDERS_PATH = '/admin/riders'

export const ADMIN_RIDERS = {
  title: 'Riders',
  onboardLabel: '+ Onboard Rider',
  searchPlaceholder: 'Search ID or Name',
  stats: [
    {
      id: 'total',
      label: 'Total Fleet',
      value: '1,284',
      subtext: '+12 this week',
      showTrend: true,
    },
    {
      id: 'available',
      label: 'Available',
      value: '432',
      subtext: 'Ready for dispatch',
    },
    {
      id: 'on_trip',
      label: 'On Trip',
      value: '815',
      valueTone: 'purple',
      subtext: 'Currently active',
      statusDot: 'orange',
    },
    {
      id: 'offline',
      label: 'Offline',
      value: '37',
      subtext: 'Inactive status',
      statusDot: 'gray',
    },
  ],
  tabs: [
    { id: 'all', label: 'All Riders' },
    { id: 'pending', label: 'Pending Review' },
    { id: 'available', label: 'Available' },
    { id: 'on_trip', label: 'On Trip' },
    { id: 'offline', label: 'Offline' },
  ],
  columns: {
    rider: 'Rider',
    vehicle: 'Vehicle',
    status: 'Status',
    active: 'Active',
    trips: 'Trips',
    rating: 'Rating',
    lastActive: 'Last Active',
  },
  riders: [
    {
      id: 'RD-8492',
      name: 'Marcus Johnson',
      initials: 'MJ',
      avatarTone: 'bg-orange-100 text-rapid-orange',
      vehicle: 'Honda Vario 150',
      plate: 'B 1234 XYZ',
      status: 'on_trip',
      statusLabel: 'On Trip',
      activeOrders: 1,
      trips: '1,432',
      rating: '4.9',
      lastActive: 'Now',
    },
    {
      id: 'RD-7381',
      name: 'Sarah Chen',
      initials: 'SC',
      avatarTone: 'bg-violet-100 text-violet-700',
      vehicle: 'Yamaha NMAX',
      plate: 'D 5678 ABC',
      status: 'available',
      statusLabel: 'Available',
      activeOrders: 0,
      trips: '892',
      rating: '4.8',
      lastActive: '2 mins ago',
    },
    {
      id: 'RD-2910',
      name: 'David Okafor',
      initials: 'DO',
      avatarTone: 'bg-gray-200 text-gray-700',
      vehicle: 'Toyota Prius',
      plate: 'L 9012 DEF',
      status: 'offline',
      statusLabel: 'Offline',
      activeOrders: 0,
      trips: '3,104',
      rating: '4.9',
      lastActive: '4 hrs ago',
    },
    {
      id: 'RD-5521',
      name: 'Amara Nwosu',
      initials: 'AN',
      avatarTone: 'bg-emerald-100 text-emerald-700',
      vehicle: 'Honda Activa',
      plate: 'F 3344 GHI',
      status: 'available',
      statusLabel: 'Available',
      activeOrders: 0,
      trips: '654',
      rating: '4.7',
      lastActive: '8 mins ago',
    },
    {
      id: 'RD-6103',
      name: 'James Okonkwo',
      initials: 'JO',
      avatarTone: 'bg-blue-100 text-blue-700',
      vehicle: 'Suzuki Access',
      plate: 'K 7788 JKL',
      status: 'on_trip',
      statusLabel: 'On Trip',
      activeOrders: 1,
      trips: '2,011',
      rating: '4.9',
      lastActive: 'Now',
    },
    {
      id: 'RD-8840',
      name: 'Fatima Bello',
      initials: 'FB',
      avatarTone: 'bg-amber-100 text-amber-800',
      vehicle: 'TVS Jupiter',
      plate: 'M 2211 MNO',
      status: 'offline',
      statusLabel: 'Offline',
      activeOrders: 0,
      trips: '421',
      rating: '4.6',
      lastActive: '1d ago',
    },
  ],
  mobile: {
    pageTitle: 'Riders',
    searchPlaceholder: 'Search riders by name, ID, or zone...',
    filters: [
      { id: 'all', label: 'All' },
      { id: 'pending', label: 'Pending' },
      { id: 'available', label: 'Available' },
      { id: 'on_trip', label: 'On Trip' },
      { id: 'offline', label: 'Offline' },
    ],
    vehicleLabel: 'VEHICLE',
    ratingLabel: 'RATING',
    riders: [
      {
        id: 'R-4921',
        name: 'Marcus Adebayo',
        initials: 'MA',
        avatarTone: 'photoDark',
        vehicle: 'Scooter',
        vehicleIcon: 'scooter',
        rating: '4.9',
        status: 'available',
        statusLabel: 'Available',
      },
      {
        id: 'R-3810',
        name: 'Sarah Jenkins',
        initials: 'SJ',
        avatarTone: 'photoLight',
        vehicle: 'Bicycle',
        vehicleIcon: 'bicycle',
        rating: '4.7',
        status: 'on_trip',
        statusLabel: 'On Trip',
      },
      {
        id: 'R-8821',
        name: 'Tunde Ojo',
        initials: 'TO',
        avatarTone: 'neutral',
        vehicle: 'Van',
        vehicleIcon: 'van',
        rating: 'New',
        ratingIsNew: true,
        status: 'offline',
        statusLabel: 'Offline',
      },
    ],
  },
}
